import React from "react";
import PrimaryButton from "../shared/primaryButton";
import { createCart } from "../../utils/api";
import { $isSideCartOpen, $productAddToCart, addProductToCartStore } from "../../utils/store";
import { __t } from "../../utils/translate";
import { Product } from "../../utils/types";
import { cartQueueManager } from "../../utils/utils";

type AddToCartButtonProps = {
    className?: string;
    product: Product;
    currency: string;
    productId?: number;
    quantity?: number;
    stockStatus?: string;
};

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
    className = "",
    product,
    currency,
    productId,
    quantity = 1,
    stockStatus = "instock",
}) => {

    const variation = product.variations_product?.find(v => v.id === productId);
    const image = variation ? variation.image : product.image;

    let attribute_summary = '';
    const attributes = {};
    if (variation) {
        variation.attributes2.map(attr => {
            attribute_summary = attribute_summary + attr.attribute_label + ': ' + attr.value_label + ', ';
            attributes[`attribute_${attr.attribute}`] = { label: attr.attribute_label, value: attr.value_label }
        })
    }

    const productData = {
        item_id: product.sku,
        item_name: product.name,
        price: product.price,
        quantity: quantity,
        currency: currency,
        slug: product.slug,
        item_category: product?.categories?.length ? product.categories[0].name : '',
        item_variant: attribute_summary
    }

    const sendPurchase = () => {
        const id = sessionStorage.getItem("session_cookie");
        if (typeof window !== "undefined" && !!window?.gtag) {
            window.gtag("event", "purchase", {
                transaction_id: id,
                value: Number(product.price) * quantity,
                currency: currency,
                items: [productData],
            });
        }
    }

    const sendAddToCart = () => {
        if (typeof window !== "undefined" && !!window?.gtag) {
            window.gtag("event", "add_to_cart", {
                value: Number(product.price) * quantity,
                currency: currency,
                items: [productData],
            })
        }
    }

    let price = variation
        ? variation.sale_price ? variation.sale_price : variation.regular_price ? variation.regular_price : variation.price
        : product.sale_price ? product.sale_price : product.regular_price ? product.regular_price : product.price;

    const new_product = {
        image: image,
        key: 0,
        line_subtotal: '',
        line_subtotal_tax: 0,
        line_tax: product.name,
        line_tax_data: { subtotal: Array(0), total: Array(0) },
        line_total: price,
        name: product.name,
        price: price,
        product_id: product.wordpress_id,
        quantity: 1,
        slug: "",
        variation: attributes,
        variation_id: product.defaultVariationID,
    };

    const handleAddToCart = async () => {
        $productAddToCart.set(true);

        const body = {
            product_id: productId,
            quantity: quantity,
        };

        addProductToCartStore(new_product);
        $isSideCartOpen.set(true);

        try {
            await cartQueueManager.addToQueue(async () => {
                await createCart(body);

                if (process.env.GATSBY_PURCHASE_EVENT === 'true') {
                    sendPurchase();
                } else {
                    sendAddToCart();
                }
            });
        } catch (error) {
            console.error('Error adding to cart:', error);
            $productAddToCart.set(false);
        }
    };

    if (stockStatus == "instock") {
        return (
            <>
                <PrimaryButton className={className} onClick={handleAddToCart}>
                    {__t("Add to cart")}
                </PrimaryButton>
            </>
        );
    }
    else {
        return (
            <PrimaryButton className={className} isDisabled={true}>
                {__t("Out of stock")}
            </PrimaryButton>
        );
    }

};

export default AddToCartButton;
